import React from "react";
import { Box, CircularProgress } from "@mui/material";

interface LoaderProps {
    color?: "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
};

const Loader: React.FC<LoaderProps> = ({ color }) => {
    return (
        <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress color={color ?? "primary"} />
        </Box>
    );
};

export default Loader;